import homePng from './home.png'
import homeWebp from './home.webp'

export default {
	home: {
		png: homePng,
		webp: homeWebp,
	},
}
